export const DEFAULT_PAGE_SIZE = 30;

export const URL_SORT_PARAMS = {
  SORT_BY: "sort_by",
  ORDER_BY: "order_by",
} as const;

export const URL_PAGE_PARAM = "page";

export const SORT_DIRECTIONS = {
  ASC: "asc",
  DESC: "desc",
} as const;

export const STORAGE_KEY_PREFIX = "NEETOUI";

export const STORAGE_KEY_SUFFIX = "FIXED_COLUMNS";

export const COLUMN_SIZING_STORAGE_KEY_SUFFIX = "COLUMN_SIZING";
